var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4843 8.13335C17.1978 8.13335 16.9686 8.36255 16.9686 8.64905V13.3401C16.9686 14.6159 15.9295 15.6512 14.6575 15.6512H3.34253C2.06664 15.6512 1.03141 14.6121 1.03141 13.3401V8.57265C1.03141 8.28615 0.802207 8.05695 0.515705 8.05695C0.229202 8.05695 0 8.28615 0 8.57265V13.3401C0 15.1851 1.50127 16.6826 3.34253 16.6826H14.6575C16.5025 16.6826 18 15.1813 18 13.3401V8.64905C18 8.36637 17.7708 8.13335 17.4843 8.13335Z",
    fill: "#838891"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63711 12.587C8.73643 12.6863 8.87014 12.7398 9.00002 12.7398C9.1299 12.7398 9.2636 12.6902 9.36292 12.587L12.6405 9.30942C12.843 9.10696 12.843 8.78226 12.6405 8.57979C12.438 8.37733 12.1133 8.37733 11.9109 8.57979L9.51572 10.9788V0.515705C9.51572 0.229202 9.28652 0 9.00002 0C8.71351 0 8.48431 0.229202 8.48431 0.515705V10.9788L6.08533 8.57979C5.88287 8.37733 5.55817 8.37733 5.3557 8.57979C5.15324 8.78226 5.15324 9.10696 5.3557 9.30942L8.63711 12.587Z",
    fill: "#838891"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.02508790366f1818f4ec9535f745576b.svg";
export { ForwardRef as ReactComponent };